var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubMenuIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1035 11.7676C10.6213 11.7676 11.041 11.3478 11.041 10.8301C11.041 10.3123 10.6213 9.89258 10.1035 9.89258C9.58575 9.89258 9.16602 10.3123 9.16602 10.8301C9.16602 11.3478 9.58575 11.7676 10.1035 11.7676Z",
    fill: "#D0D5DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1035 6.76758C10.6213 6.76758 11.041 6.34785 11.041 5.83008C11.041 5.31231 10.6213 4.89258 10.1035 4.89258C9.58575 4.89258 9.16602 5.31231 9.16602 5.83008C9.16602 6.34785 9.58575 6.76758 10.1035 6.76758Z",
    fill: "#D0D5DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1035 16.7676C10.6213 16.7676 11.041 16.3478 11.041 15.8301C11.041 15.3123 10.6213 14.8926 10.1035 14.8926C9.58575 14.8926 9.16602 15.3123 9.16602 15.8301C9.16602 16.3478 9.58575 16.7676 10.1035 16.7676Z",
    fill: "#D0D5DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubMenuIco);
export default __webpack_public_path__ + "static/media/sub_menu_ico.2f3e93c33283627297550b6ea2bb407c.svg";
export { ForwardRef as ReactComponent };